import { Component, OnInit } from '@angular/core';
import { NgbDateAdapter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Order } from 'src/app/models/order';
import { OrderService, OrderFilters } from 'src/app/services/order.service';
import { Travel } from 'src/app/models/travel';
import { NativeDateAdapter } from 'src/app/adapters/native-date-adapter';
import { TravelService } from 'src/app/services/travel.service';
import { LogisticEventsService, EventMessage } from 'src/app/services/logistic-events.service';

@Component({
  selector: 'loads-calendar',
  templateUrl: './loads-calendar.component.html',
  styleUrls: ['./loads-calendar.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NativeDateAdapter}]
})
export class LoadsCalendarComponent implements OnInit {

  date:Date = new Date();
  selectedDate:string = "";
  all:{
    date:Date,
    orders:Order[],
    active:boolean,
  }[] = [];
  filterall:{
    date:Date,
    orders:Order[],
    active:boolean,
  }[] = [];
  loading:boolean = false;

  selectedOrder:any;
  travel:any;
  plants:any[] = [];
  selectedPlant: string | null = null;
  loadPlants = false;

  constructor(private orderServ:OrderService, private modal:NgbModal, private travelServ:TravelService, private logisticEvt:LogisticEventsService) {
    this.logisticEvt.wait(resp => {
      
      let data:EventMessage = JSON.parse(resp.data);

      if (data.type == 'travel-created' || data.type == 'travel-deleted') {
        data.travel.lines.forEach(line => {
          if (line.order_id) {
            this.all.forEach(a => {
              let ord = a.orders.find(order => order.id == line.order_id);
              if (ord) {
                ord.status = data.type == 'travel-created' ? "Viaje Creado" : "Creada";
                ord.contracted = data.type == 'travel-created' ? data.travel.contracted : false;
              }
            });
          }
        });
      } else if (data.type == 'order-deleted') {//LISTO
        //Cancelado
        data.order.product_date = new Date(data.order.product_date);
        let section = this.all.find(a => a.date.getDate() == data.order.product_date.getDate() && a.date.getMonth() == data.order.product_date.getMonth() && a.date.getFullYear() == data.order.product_date.getFullYear());

        let or = section.orders.find(o => o.id == data.order.id);
        or.status = 'Cancelado';
      } else if (data.type == 'order-created') {//LISTO
        //insert into array
        data.order.product_date = new Date(data.order.product_date);
        let section = this.all.find(a => a.date.getDate() == data.order.product_date.getDate() && a.date.getMonth() == data.order.product_date.getMonth() && a.date.getFullYear() == data.order.product_date.getFullYear());

        data.order.status = 'Creada';
        section.orders.push(data.order);
      } else if (data.type == 'order-info-changed') {//LISTO
        //update order in array
        data.order.product_date = new Date(data.order.product_date);
        for (let i = 0; i < this.all.length; i++) {
          let orders = this.all[i].orders.filter(o => o.id != data.order.id);
          if (orders.length != this.all[i].orders.length) {
            this.all[i].orders = orders;
            break;
          }
        }

        let section = this.all.find(a => a.date.getDate() == data.order.product_date.getDate() && a.date.getMonth() == data.order.product_date.getMonth() && a.date.getFullYear() == data.order.product_date.getFullYear());

        section.orders.push(data.order);
      }
    });
  }

  ngOnInit() {
    this.getPlants();
    this.getOrders();
  }

  getOrders() {
    let date = new Date(this.date.getFullYear(), this.date.getMonth(), 1, 1, 1, 1);
    date.setDate(date.getDay() == 0 ? -5 : date.getDate() - date.getDay() + 1 );
    let date2 = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0, 1, 1, 1);

    let months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    this.selectedDate = months[this.date.getMonth()] + ' ' + this.date.getFullYear();

    let filter:OrderFilters = {
      date1: date,
      date2: date2,
      status: null,
      user: null,
    }

    this.loading = true;
    this.orderServ.travelOrders(filter).then(response => {
      this.loading = false;
      const orders = response.orders || [];
      const travels = response.travels_particulars || [];

      const all = [...orders, ...travels];

      this.calcDates(date, date2, all);
    });
  }

  getPlants(){
    this.plants = [];
    this.orderServ.getPlants().then((plants:any) => {
      this.loadPlants = true;
      this.plants = plants.filter((item:any, index:any, self:any) =>
        index === self.findIndex((x:any) => x.name.toLowerCase() === item.name.toLowerCase())
      );
    });
  }
  
  calcDates(dateI:Date, dateF:Date, orders:Order[]) {
    this.all = [];
    this.filterall = [];

    let date1 = new Date(dateI.valueOf());
    for ( let i = 1; date1.valueOf() <= dateF.valueOf(); i++ ) {
      this.all.push({
        date: date1,
        orders: orders.filter(order => {
          return order.product_date.toString().substring(0, 10) == date1.toString();
        }),
        active: this.date.toString() == date1.toString(),
      });
      
      date1 = new Date(dateI.valueOf());
      date1.setDate(date1.getDate() + i);

      if (i == 37) break;
    }
    this.filterall = this.all;
    this.changePlants();
  }

  changePlants(){
    this.filterall = [];
    if (this.selectedPlant) {
      const selectedPlant = this.selectedPlant.toLowerCase();

      this.filterall = this.all.map(item => {
        return {
          ...item,
          orders: item.orders.filter(order =>
            // order.source_customer_address_id === this.selectedPlant &&
            order.source_customer_address.name.toLowerCase() === selectedPlant 
          )
        };
      });
    }else 
    this.filterall = this.all;
  }

  selected($event, mo) {
    this.travel = {};
    this.selectedOrder = {};
    this.selectedOrder = $event;
    if(this.selectedOrder.particular_travel){
      this.selectedOrder = {
        id: $event.id,
        unit_type_presentation: '',
        unit_type: $event.unit_type,
        ton: $event.ton,
        product: $event.product,
        presentation: $event.presentation,
        customer: $event.customer ,
        customer_address: $event.customer_address,
        delivery_date: $event.delivery_date,
        source_customer:$event.source_customer,
        source_customer_address:{name: ''},
        created_at: $event.created_at,
        description_travel: '',

        particular_travel: true,
        purchase_order_id: $event.purchase_order_id,
        sale_order_id: $event.sale_order_id,
        // created_at:{date: ''},
        // description_travel:1,
      };

      this.travel = {
        id: $event.travel_id,
        set_id: null,
        unity: { 
          id: 0,
          unit_type: $event.unit_type,
          brand: '',
          model: '',
          licence_plate: $event.placas
        },
        operator: $event.operator ? $event.operator : $event.operator_new,
        prd_loading_date: $event.product_date,
        gas_loading_date: '',
      };

    }else if (this.selectedOrder.status != 'Cancelado' && this.selectedOrder.status != 'Creada') {
      this.loading = true;
      if(this.selectedOrder.id !== null ){
        this.travelServ.getTravelByOrder(this.selectedOrder).then(travel => {
          this.travel = travel;
          this.loading = false;
        });
      }
      else{
        this.travelServ.getTravel(this.selectedOrder.travel_id).then(travel => {
          this.travel = travel;
          this.loading = false;
        });
      }
    } else {
      this.travel = null;
    }
    this.modal.open(mo, { size: 'lg' });
  }
}
